export const routes = [{
        path: '/',
        name: 'home',
        component: () =>
            import ('@/views/Home.vue'),
        meta: {
            title: 'Home',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/tenant',
        name: 'tenant',
        component: () =>
            import ('@/views/TenantEdit.vue'),
        meta: {
            title: 'Tenant Global Settings',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/clients',
        name: 'clients',
        component: () =>
            import ('@/views/Clients.vue'),
        meta: {
            title: 'All Oauth2 Clients',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/clients/edit/:uuid',
        name: 'clientEdit',
        component: () =>
            import ('@/views/ClientEdit.vue'),
        meta: {
            title: 'Edit Oauth2 Clients',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/webhooks',
        name: 'webhooks',
        component: () =>
            import ('@/views/Webhooks.vue'),
        meta: {
            title: 'All Webhooks',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/webhooks/edit/:uuid',
        name: 'webhookEdit',
        component: () =>
            import ('@/views/WebhookEdit.vue'),
        meta: {
            title: 'Edit Webhook',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/keys',
        name: 'keys',
        component: () =>
            import ('@/views/Keys.vue'),
        meta: {
            title: 'All Keys',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/keys/edit/:uuid',
        name: 'keyEdit',
        component: () =>
            import ('@/views/KeyEdit.vue'),
        meta: {
            title: 'Edit Key',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/resources',
        name: 'resources',
        component: () =>
            import ('@/views/Resources.vue'),
        meta: {
            title: 'All Oauth2 API Resources',
            requiresAuth: true,
            layout: 'dashboard'
        },
    },
    {
        path: '/resources/edit/:uuid',
        name: 'resourceEdit',
        component: () =>
            import ('@/views/ResourceEdit.vue'),
        meta: {
            title: 'Edit Oauth2 API Resource',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/roles',
        name: 'roles',
        component: () =>
            import ('@/views/Roles.vue'),
        meta: {
            title: 'All Roles',
            requiresAuth: true,
            layout: 'dashboard'
        },
    },
    {
        path: '/roles/edit/:uuid',
        name: 'roleEdit',
        component: () =>
            import ('@/views/RoleEdit.vue'),
        meta: {
            title: 'Edit Role',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/Users.vue'),
        meta: {
            title: 'All Users',
            requiresAuth: true,
            layout: 'dashboard'
        },
    },
    {
        path: '/user-settings',
        name: 'userSettings',
        component: () =>
            import ('@/views/UserSettings.vue'),
        meta: {
            title: 'User Settings',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/subscription',
        name: 'subscription',
        component: () =>
            import ('@/views/Subscription.vue'),
        meta: {
            title: 'Subscription',
            requiresAuth: true,
            layout: 'dashboard'
        }
    },
    {
        path: '/callback',
        name: 'callback',
        component: () =>
            import ('@/views/Callback.vue'),
        meta: {
            title: 'Callback',
            requiresAuth: false,
            layout: 'default'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('@/views/Login.vue'),
        meta: {
            title: 'Login',
            requiresAuth: false,
            layout: 'default'
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: () =>
            import ('@/views/Logout.vue'),
        meta: {
            title: 'Logout',
            requiresAuth: true,
            layout: 'default'
        }
    },
    {
        path: '/calculator',
        name: 'calculator',
        component: () =>
            import ('@/views/Calculator.vue'),
        meta: {
            title: 'Calculator',
            requiresAuth: false,
            layout: 'default'
        }
    },
]